import React from 'react';

function EmptyState() {
  return (
    <div className="profile-visits-card__empty">
      Noch keine Profilbesuche von anderen Piraten.
    </div>
  );
}

function VisitRow({ visit }) {
  const targetHref = visit?.app_url || (visit?.slug ? `#/profil/${encodeURIComponent(visit.slug)}` : '#');

  return (
    <a className="profile-visits-card__item" href={targetHref}>
      <img
        className="profile-visits-card__avatar"
        src={visit?.avatar_url || 'https://app.pfandpirat.com/wp-content/uploads/Pfandpirat-7.jpg'}
        alt={visit?.display_name || visit?.username || 'Profilavatar'}
      />
      <div className="profile-visits-card__meta">
        <div className="profile-visits-card__name">
          {visit?.display_name || visit?.username || 'Unbekannt'}
        </div>
        <div className="profile-visits-card__subline">
          @{visit?.slug || visit?.username || 'profil'}
        </div>
      </div>
      <div className="profile-visits-card__time">
        {visit?.last_seen_human || 'gerade eben'}
      </div>
    </a>
  );
}

export default function ProfileVisitsCard({ visits = [], loading = false, error = null, enabled = true }) {
  if (!enabled) {
    return null;
  }

  return (
    <section className="profile-visits-card">
      <div className="profile-visits-card__header">
        <div>
          <div className="profile-visits-card__eyebrow">👀 Community</div>
          <h3 className="profile-visits-card__title">Zuletzt besucht von</h3>
        </div>
        <div className="profile-visits-card__hint">Die letzten Piraten, die dein Profil angesehen haben.</div>
      </div>

      {loading ? (
        <div className="profile-visits-card__empty">Besucher werden geladen ...</div>
      ) : error ? (
        <div className="profile-visits-card__empty">Die Profilbesuche konnten gerade nicht geladen werden.</div>
      ) : visits.length === 0 ? (
        <EmptyState />
      ) : (
        <div className="profile-visits-card__list">
          {visits.map((visit) => (
            <VisitRow key={`${visit?.user_id || visit?.slug}-${visit?.last_seen_at || ''}`} visit={visit} />
          ))}
        </div>
      )}
    </section>
  );
}
